import { removeDosageDiaryFromProfile } from '../service/removeProductFromDosageDiary';
import showToast from '../components/ToastComponent';

export function useToUnassignProductFromDDProfile(
  token: string,
  setFetcher: () => void,
): [(val: number) => Promise<void>] {
  async function handleRemoval(product: number) {
    const result = await removeDosageDiaryFromProfile(token, product);
    if (result === 204) {
      showToast({
        message: 'Product removed successfully',
        type: 'success',
      });
      setFetcher();
      return;
    }
    showToast({
      message: result as string,
      type: 'info',
    });
  }

  return [handleRemoval];
}
